import { TruncatedText } from '@noor/ui';
import { useMerchant } from '@/entities/merchant';
import { shortId } from '@/entities/moderation';

interface VendorCellProps {
  merchantId: string | null | undefined;
}

export function VendorCell({ merchantId }: VendorCellProps) {
  const id = merchantId?.trim() ?? '';
  const { data: merchant } = useMerchant(id || undefined, id !== '');
  const name = merchant?.name?.trim();
  if (id === '') return <>—</>;
  return (
    <TruncatedText
      text={name !== undefined && name !== '' ? name : shortId(id)}
      className="block max-w-56"
    />
  );
}
